import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { NestedPageBlockConfig } from '@front-platform/content-builder';
import { nestedPageBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface NestedPageBlockRuntimeConfig {}

export type NestedPageBlockConfigInput = Partial<
  Omit<NestedPageBlockConfig, keyof NestedPageBlockRuntimeConfig> & NestedPageBlockRuntimeConfig
>;
export type NestedPageBlockResolvedConfig = Omit<
  NestedPageBlockConfig,
  keyof NestedPageBlockRuntimeConfig
> &
  Partial<NestedPageBlockRuntimeConfig>;
export interface NestedPageBlockContract extends ConfigComponentContract<
  NestedPageBlockConfigInput,
  NestedPageBlockResolvedConfig
> {}

@Component({
  selector: 'app-nested-page-block',
  templateUrl: './nested-page-block.component.html',
  standalone: false,
})
export class NestedPageBlockComponent implements NestedPageBlockContract {
  readonly config = input<NestedPageBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    NestedPageBlockConfig,
    NestedPageBlockRuntimeConfig
  >(nestedPageBlockResolveConfig, () => ({ config: this.config() }));
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(NestedPageBlockComponent, { 'keyAliases': {} });
